module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Mailbox-f6ffa2fb2fd53a0dce7ff8f1c0c62b74.svg";